import { RESERVED_PATH_SUFFIXES } from '$lib/editor/utils';

export function match(value: string) {
	const [lastComponent] = value.split('/').slice(-1);
	if (!lastComponent) return true;

	if (RESERVED_PATH_SUFFIXES.includes(lastComponent)) {
		return false;
	} else if (
		lastComponent.startsWith('~') &&
		!RESERVED_PATH_SUFFIXES.includes(lastComponent.slice(1)) &&
		!/[01]/.test(lastComponent.charAt(1))
	) {
		return false;
	}

	return true;
}
